import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page } from "~/components/ui/page";
import { Skeleton } from "~/components/ui/states";
import { emptyQuote, QuoteEditor } from "~/features/sales/quote-editor";
import { companyQuery } from "~/features/sales/send-email";

export const Route = createFileRoute("/_app/quotes/new")({ component: NewQuote });

function NewQuote() {
  const company = useQuery(companyQuery);
  if (company.isPending)
    return (
      <Page>
        <Skeleton className="h-96 w-full" />
      </Page>
    );
  return <QuoteEditor initial={emptyQuote(company.data?.quoteValidityDays ?? 30)} />;
}
